import styles from './style.module.scss';
import { UserSizeDonut } from './user-size-donut';
import { SessionCooldownTimer } from './session-cooldown-timer';
import { Boosters } from './boosters';
import { Limit } from './limit';
import { useVisibilityChange } from 'shared/hooks';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'shared/constants';
import { checkAirdrop, AirdropCheckResponse } from 'shared/api';
import { AirdropModal } from 'components/modals/airdrop-modal/airdrop-modal';
import { useMarketStore } from 'shared/store';

export const MainScreenModule = () => {
  const navigate = useNavigate();
  const [isExiting, setIsExiting] = useState(false);
  const [showAirdropModal, setShowAirdropModal] = useState(false);
  const [airdropData, setAirdropData] = useState<AirdropCheckResponse['airdrop'] | null>(null);
  const marketItems = useMarketStore((state) => state.marketItems);

  useVisibilityChange();

  useEffect(() => {
    // Ждем пока загрузятся market items
    if (!marketItems || Object.keys(marketItems).length === 0) {
      // console.log('MainScreen: Market items not loaded yet, marketItems:', marketItems);
      return;
    }

    // console.log('MainScreen: Market items loaded:', marketItems);
    // console.log('MainScreen: Checking airdrop...');
    
    const checkUserAirdrop = async () => {
      try {
        const response = await checkAirdrop();
        // console.log('Airdrop response:', response.data);
        if (response.data.has_airdrop && response.data.airdrop) {
          setAirdropData(response.data.airdrop);
          setShowAirdropModal(true);
        }
      } catch (error) {
        console.error('Error checking airdrop:', error);
      }
    };

    checkUserAirdrop();
  }, [marketItems]);

  const handleGameStart = () => {
    setIsExiting(true);
    setTimeout(() => {
      navigate(ROUTES.SESSION);
    }, 0);
  };

  const handleAirdropSuccess = () => {
    // console.log('Airdrop claimed successfully!');
    setShowAirdropModal(false);
    setAirdropData(null);
  };

  return (
    <>
      <div className={styles.root}>
        <div className={styles.container}>
          <div className={isExiting ? styles.animateFromTop : ''}>
            <Boosters />
          </div>

          <UserSizeDonut onGameStart={handleGameStart} />

          <SessionCooldownTimer onGameStart={handleGameStart} />

          <div className={isExiting ? styles.animateFromBottom : ''}>
            <Limit />
          </div>
        </div>
        
        {/* Оверлей с основным фоном для плавного перехода */}
        {isExiting && (
          <div className={styles.transitionOverlay} />
        )}
      </div>

      {airdropData && (
        <AirdropModal
          isOpen={showAirdropModal}
          onClose={() => setShowAirdropModal(false)}
          airdropData={airdropData}
          onSuccess={handleAirdropSuccess}
        />
      )}
    </>
  );
};
